var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"customer-contact-edit","toptitle":"Ansprechpartner bearbeiten","title":`${_vm.customerContact.firstName} ${_vm.customerContact.lastName}`,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('customer-contact-form',{attrs:{"customerContact":_vm.customerContact,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }